import axios from '@/axios';

/**
 * [전자계약 v1→v2 전환] 이 두 목록은 contracts-api 로 보낸다.
 *
 * - 절대 URL 프리픽스 방식: `VUE_APP_CONTRACTS_API_URL` 이 비어 있으면 상대경로가 되어
 *   기존 v1(inapi, `src/axios.js` 의 baseURL)로 그대로 간다 — env 가 트래픽 스위치다.
 *   절대 URL 이어도 같은 axios 인스턴스를 쓰므로 인증 인터셉터(Bearer accessTokenCerti)가
 *   동일하게 붙는다(contracts-api 는 inapi 와 JWT_ACCESS_SECRET 을 공유).
 * - v2 라우트는 CERTILIFE 롤을 허용하고 서비스 스코프(전 병원 조회·병원명 검색·테스트업체
 *   제외)도 v1 과 동일하게 구현돼 있다(contract-*-query.service, v1 대조 이식).
 */
const contractsApiUrl = process.env.VUE_APP_CONTRACTS_API_URL || '';

export const PrixContractApi = {
  /**
   * 근로계약서 목록 조회
   * @param {Object} params - 검색 파라미터
   * @returns {Promise}
   */
  getLaborContracts(params) {
    return axios.get(`${contractsApiUrl}/contracts/prix/labor/list`, { params });
  },


  /**
   *   목록 조회
   * @param {Object} params - 검색 파라미터
   * @returns {Promise}
   */
  getConsentContracts(params) {
    return axios.get(`${contractsApiUrl}/contracts/prix/consent/list`, { params });
  },
};
